import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'ko',
    fallbackLng: ['ko', 'en'],
    ns: ['common', 'myInfo', 'main', 'login', 'previousEmployment', 'dependents'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{ns}}/{{lng}}.json',
    },
    debug: false,
    react: {
      useSuspense: true, //화면 전환 시 번역될때까지 로딩 처리
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
